import { render, staticRenderFns } from "./PickingPointsAdd.vue?vue&type=template&id=a86d1ad0"
import script from "./PickingPointsAdd.vue?vue&type=script&lang=js"
export * from "./PickingPointsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports